import { useState, useRef, useEffect } from 'react';
import { useStore } from '../../../store/useStore';
import { FishingSpot } from './FishingSpot';
import { fishItems } from '../../../data/fishItems';
import { Html } from '@react-three/drei';
import { useAudio } from '../../../hooks/useAudio';

export const FishingManager = () => {
    const [gameState, setGameState] = useState<'idle' | 'waiting' | 'bite' | 'caught'>('idle');
    const [catchResult, setCatchResult] = useState<any>(null);
    const [timer, setTimer] = useState(0);
    const addToInventory = useStore((state) => state.addToInventory);
    const { playSfx } = useAudio();

    // Reset when closing
    useEffect(() => {
        if (gameState === 'caught') {
            const t = setTimeout(() => setGameState('idle'), 3000); // Auto close result after 3s
            return () => clearTimeout(t);
        }
    }, [gameState]);

    const startFishing = () => {
        if (gameState !== 'idle') return;
        setGameState('waiting');
        playSfx('click'); // Cast sound

        // Random wait time 2-5s
        const waitTime = Math.random() * 3000 + 2000;

        setTimeout(() => {
            setGameState('bite');
            playSfx('click'); // Splash sound?

            // Player has 1.5s to click
            setTimeout(() => {
                setGameState((prev) => {
                    if (prev === 'bite') {
                        // Missed it
                        return 'idle';
                    }
                    return prev;
                });
            }, 1500);

        }, waitTime);
    };

    const handleReel = () => {
        if (gameState === 'bite') {
            // Success!
            const roll = Math.random();
            let catchItem;

            // Loot Table
            if (roll < 0.1) catchItem = fishItems.find(i => i.rarity === 'rare'); // 10%
            else if (roll < 0.3) catchItem = fishItems.find(i => i.rarity === 'uncommon'); // 20%
            else if (roll < 0.8) catchItem = fishItems.find(i => i.rarity === 'common'); // 50%
            else catchItem = fishItems.find(i => i.rarity === 'trash'); // 20%

            // Fallback
            if (!catchItem) catchItem = fishItems[0];

            setCatchResult(catchItem);
            setGameState('caught');
            addToInventory({
                id: Math.random().toString(),
                name: catchItem.name,
                icon: catchItem.icon,
                value: catchItem.value
            });
            playSfx('click'); // Coin sound or happy sound
        } else {
            // Clicked too early
            setGameState('idle');
        }
    };

    return (
        <group>
            {/* Spots */}
            {/* Pond Spot */}
            <FishingSpot position={[-60, -4, -60]} onInteract={startFishing} />

            {/* River Spots */}
            <FishingSpot position={[0, -4, 30]} onInteract={startFishing} />
            <FishingSpot position={[40, -4, 32]} onInteract={startFishing} />
            <FishingSpot position={[-40, -4, 28]} onInteract={startFishing} />

            {/* Mini-Game Overlay - Only visible when fishing */}
            {gameState !== 'idle' && (
                <Html position={[0, 0, 0]} fullscreen style={{ pointerEvents: 'none' }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                        pointerEvents: 'auto'
                    }}>
                        {gameState === 'waiting' && <div style={{ fontSize: '24px', color: 'white', textShadow: '0 2px 4px black' }}>Waiting...</div>}

                        {gameState === 'bite' && (
                            <button
                                onClick={handleReel}
                                style={{
                                    fontSize: '32px',
                                    padding: '20px 40px',
                                    background: 'red',
                                    color: 'white',
                                    border: '4px solid white',
                                    borderRadius: '50%',
                                    cursor: 'pointer',
                                    animation: 'pulse 0.2s',
                                    fontWeight: 'bold'
                                }}
                            >
                                PULL!
                            </button>
                        )}

                        {gameState === 'caught' && catchResult && (
                            <div style={{
                                background: 'rgba(0,0,0,0.8)',
                                padding: '20px',
                                borderRadius: '12px',
                                textAlign: 'center',
                                color: 'white',
                                border: '2px solid gold'
                            }}>
                                <div style={{ fontSize: '40px' }}>{catchResult.icon}</div>
                                <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#ffd700' }}>Caught {catchResult.name}!</div>
                                <div style={{ color: '#aaa' }}>{catchResult.description}</div>
                                <div style={{ marginTop: '10px', fontSize: '14px', color: 'gold' }}>Value: {catchResult.value}g</div>
                            </div>
                        )}
                    </div>
                </Html>
            )}
        </group>
    );
};
